export const PRODUCT_PRICE_TYPES = {
  PER_UNIT: "per_unit",
  STARTS_AT: "starts_at",
};

export const PRODUCT_PRICE_TYPE_OPTIONS = [
  { value: PRODUCT_PRICE_TYPES.PER_UNIT, label: "Standard price" },
  { value: PRODUCT_PRICE_TYPES.STARTS_AT, label: "Starts at" },
];

export const isStartsAtPrice = (item = {}) =>
  item.priceStartsAt === true || item.priceType === PRODUCT_PRICE_TYPES.STARTS_AT;

const INVARIANT_SELL_BY_UNITS = new Set(["each", "dozen", "lb"]);

const SELL_BY_UNIT_PLURALS = {
  item: "items",
  piece: "pieces",
  set: "sets",
  pair: "pairs",
  order: "orders",
  bundle: "bundles",
  bag: "bags",
  jar: "jars",
  case: "cases",
  bushel: "bushels",
  bale: "bales",
  roll: "rolls",
};

export const formatPriceUnit = (unit = "") => String(unit || "").trim();

export const formatSellByUnit = (unit = "", quantity = 1) => {
  const cleanUnit = formatPriceUnit(unit);
  if (!cleanUnit) return "";

  const normalizedUnit = cleanUnit.toLowerCase();
  if (INVARIANT_SELL_BY_UNITS.has(normalizedUnit)) return cleanUnit;
  if (Number(quantity) === 1) return cleanUnit;
  if (SELL_BY_UNIT_PLURALS[normalizedUnit]) return SELL_BY_UNIT_PLURALS[normalizedUnit];
  if (cleanUnit.endsWith("s")) return cleanUnit;

  return `${cleanUnit}s`;
};

export const formatAvailability = (quantity = 1, unit = "") => {
  const cleanQuantity = Number(quantity ?? 1);
  const displayQuantity = Number.isFinite(cleanQuantity) ? cleanQuantity : 1;
  const displayUnit = formatSellByUnit(unit, displayQuantity);

  return displayUnit ? `${displayQuantity} ${displayUnit}` : `${displayQuantity}`;
};

export const formatProductPrice = (item = {}, options = {}) => {
  const { includeUnit = true } = options;
  const price = Number(item.price || 0);
  const prefix = isStartsAtPrice(item) ? "Starts at " : "";
  const unit = includeUnit && item.unit ? ` / ${formatPriceUnit(item.unit)}` : "";

  return `${prefix}$${price.toFixed(2)}${unit}`;
};
